// extracted by mini-css-extract-plugin
export default {"DateParagraph":"NotificationsDropdown_DateParagraph__ixjUF","IconDiv":"NotificationsDropdown_IconDiv__0SmD4","TextDiv":"NotificationsDropdown_TextDiv__3SM10"};